import React, { Component, Fragment } from "react";
import AutoInput from "../containers/AutoInput";
import withValues from "../hocs/withValues";
import { getValue } from "../utils/models";
import { Row, Col } from "antd";
import MapForm from "./MapForm";

class RateEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      customer: getValue(this.props.values, "customer"),
      customerQuery: null,
      vehicle: getValue(this.props.values, "vehicle"),
      vehicleQuery: null,
      currency: getValue(this.props.values, "currency"),
      fetching: false,
      showContent: false,
      origin: null,
      destination: null,
      billType: getValue(this.props.values, "billType")
    };
  }

  componentWillMount() {
    setTimeout(() => {
      this.setState({ showContent: true });
    }, 500);
  }

  componentDidUpdate(prevProps) {
    if (this.props.values.customer !== prevProps.values.customer) {
      this.setState({
        customer: getValue(this.props.values, "customer")
      });
    }

    if (this.props.values.billType !== prevProps.values.billType) {
      this.setState({
        billType: getValue(this.props.values, "billType")
      });
    }

    if (this.props.values.vehicle !== prevProps.values.vehicle) {
      this.setState({
        vehicle: getValue(this.props.values, "vehicle")
      });
    }

    if (this.props.values.currency !== prevProps.values.currency) {
      this.setState({
        currency: getValue(this.props.values, "currency")
      });
    }

    if (this.props.values.dispatchtype !== prevProps.values.dispatchtype) {
      this.setState({
        dispatchtype: getValue(this.props.values, "dispatchtype")
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (!this.state.type) {
      this.setState({ type: getValue(nextProps.values, "type") });
    }
  }

  getCustomerFilter() {
    let customerFilter = {
      or: [
        {
          id: this.state.customer
        }
      ]
    };

    if (this.state.customerQuery) {
      customerFilter.or = [
        ...customerFilter.or,
        {
          active: true,
          name: {
            contains: this.state.customerQuery
          }
        }
      ];
    }

    return customerFilter;
  }

  renderMap() {
    if (this.state.origin && this.state.destination) {
      this.setState({ showContent: false }, () => {
        this.setState({ showContent: true });
      });
    }
  }

  render() {
    return (
      <Fragment>
        <Row gutter={10}>
          <Col span={24}>
            <AutoInput
              form={this.props.form}
              disabled
              model={"rates"}
              id={this.props.id}
              autoSave
              attribute={"customer"}
              value={getValue(this.props.values, "customer")}
              onSearch={value => {
                this.setState({ customerQuery: value });
              }}
              onChange={value => {
                this.setState({ customer: value });
              }}
              placeholder={"Busca un cliente"}
              filter={this.getCustomerFilter()}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              disabled
              model={"rates"}
              id={this.props.id}
              autoSave
              attribute={"origin"}
              value={getValue(this.props.values, "origin")}
              filter={{ customer: this.state.customer }}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              disabled
              model={"rates"}
              id={this.props.id}
              autoSave
              attribute={"destination"}
              value={getValue(this.props.values, "destination")}
              filter={{ customer: this.state.customer }}
            />
          </Col>
          <Col span={24}>
            <div style={{ height: "400px", padding: "0 25px" }}>
              {this.state.showContent && (
                <MapForm
                  center={{
                    lat: getValue(this.props.values, "lat"),
                    lng: getValue(this.props.values, "lng")
                  }}
                  form={this.props.form}
                  googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyBzhd2gYGYfl0bdmCeLGrOjtwzcKcfYmF0&v=3.exp&libraries=geometry,drawing,places"
                  loadingElement={<div style={{ height: "100%" }} />}
                  containerElement={
                    <div
                      style={{
                        height: 400,
                        borderRadius: 3,
                        overflow: "hidden"
                      }}
                    />
                  }
                  mapElement={<div style={{ height: "100%" }} />}
                  locate={false}
                  directions={{
                    origin: this.props.values.origin,
                    destination: this.props.values.destination
                  }}
                />
              )}
            </div>
          </Col>
          <Col span={24}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              autoSave
              attribute={"dispatchtype"}
              value={getValue(this.props.values, "dispatchtype")}
            />
          </Col>
          <Col span={24}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              autoSave
              ajax
              attribute={"vehicletype"}
              value={getValue(this.props.values, "vehicletype")}
              placeholder={"Ingresa un número de placas/económico"}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              autoSave
              attribute={"amount"}
              value={getValue(this.props.values, "amount")}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              type={"model"}
              items={["MXN", "USD"]}
              autoSave
              attribute={"currency"}
              value={this.state.currency}
              onChange={value => {
                this.setState({ currency: value });
              }}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              autoSave
              value={this.state.supplierCost}
              attribute={"supplierCost"}
            />
          </Col>
          <Col span={12}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              type={"model"}
              items={["MXN", "USD"]}
              autoSave
              attribute={"supplierCurrency"}
              value={this.state.supplierCurrency}
              onChange={value => {
                this.setState({ supplierCurrency: value });
              }}
            />
          </Col>
          <Col span={24}>
            <AutoInput
              form={this.props.form}
              disabled={this.props.disabled}
              model={"rates"}
              id={this.props.id}
              autoSave
              value={this.state.dueDate}
              attribute={"dueDate"}
            />
          </Col>
        </Row>
      </Fragment>
    );
  }
}

export default withValues(RateEdit);



// WEBPACK FOOTER //
// ./src/forms/RateEdit.js